module.exports = __webpack_public_path__ + "img/back_300.c88782b3.png";